import { useMemo } from "react";

import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  Typography,
} from "@material-ui/core";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import EmailIcon from "@material-ui/icons/Email";
import ApartmentIcon from "@material-ui/icons/Apartment";

import { computeUserVisualName, User } from "../../../graphql/models";

export type UserListDetailProps = {
  user: User;
};

export function UserListDetail(props: UserListDetailProps) {
  const { user } = props;

  const userVisualName = useMemo(() => {
    return computeUserVisualName(user);
  }, [user]);

  const userBuildings = useMemo(() => {
    return user.buildings.map((v) => v.name).join(", ");
  }, [user]);

  return (
    <Box component="li">
      <List
        component="nav"
        aria-labelledby={`apartment-${user?.id}-data-list-subheader`}
        style={{ width: "100%" }}
      >
        <ListItem>
          <ListItemIcon>
            <AccountBoxIcon />
          </ListItemIcon>
          <Typography variant="caption">{userVisualName}</Typography>
        </ListItem>
        {user.email && (
          <ListItem>
            <ListItemIcon>
              <EmailIcon />
            </ListItemIcon>
            <Typography variant="caption">{user.email}</Typography>
          </ListItem>
        )}
        {user.buildings?.length > 0 && (
          <ListItem>
            <ListItemIcon>
              <ApartmentIcon />
            </ListItemIcon>
            <Typography variant="caption">{userBuildings}</Typography>
          </ListItem>
        )}
      </List>
    </Box>
  );
}
